/**
 * 订单接口
 * 
 * @author 杨斌
 * @since 2018-10-17
 */
import common from './common'
import store from './store'

var ApiList = {};

//API 接口

/**
 * 获取卡包列表
 * @param {*} okCb 
 * @param {*} failCb 
 */
ApiList.getMyCards = function (lastId, limit, openStatus, selectTypeCode,word, startDate, endDate, okCb, failCb) {
    var p = {
        limit,
        openStatus,
        selectTypeCode,
        word,
        startDate,
        endDate,
    }
    if (lastId) {
        p['lastId'] = lastId
    }
    
    common.Api('/customer/api/vcard/myCards.json', p, okCb, failCb)
}

/**
 * 获取可选择的分类信息
 * @param {*} okCb 
 * @param {*} failCb 
 */
ApiList.getSelectTypes = function (okCb, failCb) {
    var p = {}
    
    common.Api('/customer/api/vmall/selectTypes.json', p, okCb, failCb)
}

/**
 * 刮开卡密
 * @param {*} gainId 
 * @param {*} okCb 
 * @param {*} failCb 
 */
ApiList.open = function (gainId, okCb, failCb) {
    var p = {
        gainId
    }
    
    common.Api('/customer/api/vcard/open.json', p, okCb, failCb)
}

/**
 * 查看卡密
 * @param {*} gainId 
 * @param {*} okCb 
 * @param {*} failCb 
 */
ApiList.secret = function (gainId, okCb, failCb) {
    var p = {
        gainId
    }
    
    common.Api('/customer/api/vcard/secret.json', p, okCb, failCb)
}

/**
 * 卡密充值
 * @param {*} gainId 
 * @param {*} phone 
 * @param {*} okCb 
 * @param {*} failCb 
 */
ApiList.charge = function (gainId, phone, okCb, failCb) {
    var p = {
        gainId,
        phone,
    }
    
    common.Api('/customer/api/vcard/charge.json', p, okCb, failCb)
}


/**
 * 晌网商品规格查询
    /customer/api/vcard/shangwangSkuList.json

    RequireLogin: true

    参数
    gainId: integer - 卡获取ID
    返回
    shangwangSkus: list[object]? -
    id: integer -
    title: string -
 * @param {*} gainId 
 * @param {*} okCb 
 * @param {*} failCb 
 */
ApiList.shangwangSkuList = function (gainId, okCb, failCb) {
    var p = {
        gainId
    }
    
    common.Api('/customer/api/vcard/shangwangSkuList.json', p, okCb, failCb)
}


/**
 * 晌网提货
    /customer/api/vcard/pickUp.json

    RequireLogin: true

    参数
    gainId: integer - 卡获取ID
    receiverAddress: string - 收件人地址
    receiverName: string - 收件人名称
    receiverPhone: string - 收件人手机号
    skuId: integer? - 晌网规格ID
    返回
 * @param {*} gainId 
 * @param {*} okCb 
 * @param {*} failCb 
 */
ApiList.pickUp = function (gainId, receiverAddress, receiverName, receiverPhone, skuId, okCb, failCb) {
    var p = {
        gainId,
        receiverAddress,
        receiverName,
        receiverPhone,
        skuId
    }
    
    common.Api('/customer/api/vcard/pickUp.json', p, okCb, failCb)
}


/**
 * 晌网提货状态查询
    /customer/api/vcard/pickUpStatus.json

    RequireLogin: true

    参数
    gainId: integer - 卡获取ID
    返回
    picked: boolean - 是否已提货
    receiverAddress: string? - 收件人地址
    receiverName: string? - 收件人名称
    receiverPhone: string? - 收件人电话
 * @param {*} gainId 
 * @param {*} okCb 
 * @param {*} failCb 
 */
ApiList.pickUpStatus = function (gainId, okCb, failCb) {
    var p = {
        gainId
    }
    
    common.Api('/customer/api/vcard/pickUpStatus.json', p, okCb, failCb)
}

/**
 * 批量删除卡券
 * @param {*} gainIds 
 * @param {*} okCb 
 * @param {*} failCb 
 */
ApiList.deleteCard = function (gainIds, okCb, failCb) {
    var p = {
        gainIds
    }
    
    common.Api('/customer/api/vcard/obsoleteBatch.json', p, okCb, failCb)
}

export default ApiList;



// WEBPACK FOOTER //
// ./src/api/wallet-api.js